import { render } from "./ClipsComponent.vue?vue&type=template&id=61f156ca"
import script from "./ClipsComponent.vue?vue&type=script&lang=js"
export * from "./ClipsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__